import { render, staticRenderFns } from "./sku-list2.vue?vue&type=template&id=87784306&scoped=true"
import script from "./sku-list2.vue?vue&type=script&lang=ts"
export * from "./sku-list2.vue?vue&type=script&lang=ts"
import style0 from "./sku-list2.vue?vue&type=style&index=0&id=87784306&prod&lang=less&scoped=true"
import style1 from "./sku-list2.vue?vue&type=style&index=1&id=87784306&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87784306",
  null
  
)

export default component.exports